export interface XPState {
  total: number;
  level: number;
  completedModules: string[];
  character: 'gamer' | 'influencer' | 'student' | null;
  alias: string;
}

const LEVELS = [
  { level: 1, label: 'Privacy Rookie',    min: 0    },
  { level: 2, label: 'Data Scout',        min: 150  },
  { level: 3, label: 'Cookie Crusher',    min: 400  },
  { level: 4, label: 'Algorithm Buster',  min: 750  },
  { level: 5, label: 'Privacy Champion',  min: 1200 },
  { level: 6, label: 'Digital Guardian',  min: 1800 },
];

const ALIASES = [
  'Shadow Fox', 'Pixel Ghost', 'Cipher Wolf', 'Data Hawk', 'Neon Phantom',
  'Vault Keeper', 'Byte Shield', 'Echo Mask', 'Prism Guard', 'Ghost Signal',
];

const KEY = 'pe_public_xp';

export function loadXP(): XPState {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  return {
    total: 0,
    level: 1,
    completedModules: [],
    character: null,
    alias: ALIASES[Math.floor(Math.random() * ALIASES.length)],
  };
}

export function saveXP(state: XPState): XPState {
  const level = LEVELS.filter(l => state.total >= l.min).pop()!.level;
  const next = { ...state, level };
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function addXP(amount: number, moduleId?: string): XPState {
  const state = loadXP();
  if (moduleId && state.completedModules.includes(moduleId)) {
    return state; // already earned — no double XP
  }
  return saveXP({
    ...state,
    total: state.total + amount,
    completedModules: moduleId
      ? [...state.completedModules, moduleId]
      : state.completedModules,
  });
}

export function getLevelInfo(xp: number) {
  const current = LEVELS.filter(l => xp >= l.min).pop()!;
  const next = LEVELS.find(l => l.min > xp);
  const progress = next
    ? Math.round(((xp - current.min) / (next.min - current.min)) * 100)
    : 100;
  return { current, next, progress };
}

export function setCharacter(char: XPState['character']): XPState {
  const state = loadXP();
  return saveXP({ ...state, character: char });
}
